/* 
 *  Created by SGiri 02/14/2018
 */

import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { CommonService } from '~util/common.service';
import { environment } from "~environment";

@Injectable()
export class BI_HttpService {

  constructor(private http: HttpClient, private commonService: CommonService) {
  }

  public get(url: string) {
    return this.http.get(environment.baseUrl + url).catch(err => { this.commonService.showError(err); throw err; });
  }

  public getNoError(url: string) {
    return this.http.get(environment.baseUrl + url);
  }

  public post(url: string, data: any) {
    return this.http.post(environment.baseUrl + url, data).catch(err => { this.commonService.showError(err); throw err; });
  }

  public postWithOptions(url: string, data: any, options: any) {
    return this.http.post(environment.baseUrl + url, data, options).catch(err => { this.commonService.showError(err); throw err; });
  }

  getAssets(assetName: string) {
    return this.http.get('assets/' + assetName);
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/services/http.service.ts